<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <v-card tile class="d-flex flex-column justify-center align-center">
        <h1 class="text-h2 my-5">Network Error</h1>
        <h2 class="error--text font-weight-light">{{ networkIssue }}</h2>
        <h2 class="text-h4 my-5 grey--text text--darken-3">Uh-Oh!</h2>
        <h3 class="font-weight-light mb-5 grey--text text--darken-2">
          IT LOOKS LIKE YOU'RE EXPERIENCING SOME NETWORK ISSUES, PLEASE CLICK
          THE BACK BUTTON AND TRY AGAIN
        </h3>
        <v-btn large color="primary" class="my-5" :to="{ path: '/' }"
          >กลับหน้าหลัก
        </v-btn>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: true,
    }
  },
  props: {
    networkIssue: {
      type: String,
    },
  },
}
</script>
